module.exports = __webpack_public_path__ + "img/react-native.97f84baa.png";